<template>
    <div>
        <p>
            <b-checkbox v-model="show_character_option">Autoriser des caractères non alphanumériques dans les mots</b-checkbox>
        </p>
        <p v-if="show_character_option">
            Caractères non alphanumériques contenus dans les mots
            <b-input v-model="character" placeholder="ex: -_'" />
        </p>

        <div class="mt-2">
            <strong>Recherches</strong>
            <b-table-simple small bordered class="mt-1">
                <b-thead>
                    <b-tr>
                        <b-th>Type</b-th>
                        <b-th>Valeur de recherche</b-th>
                        <b-th>From (colonne à parcourir)</b-th>
                        <b-th>Remplacement
                            <i :id="'replace_help_' + id" class="fas fa-question-circle text-muted" style="cursor: help;"></i>
                            <b-popover :target="'replace_help_' + id" triggers="hover focus" placement="top" custom-class="cec-replace-help">
                                <template #title>Valeurs possibles pour "Remplacement"</template>
                                <ul class="pl-3 mb-1">
                                    <li><code>${match}</code> : texte trouvé, en minuscule</li>
                                    <li><code>${match_sensitive}</code> : texte trouvé, avec sa casse d'origine</li>
                                    <li><code>${list[match]}</code> : 1er mot (valeur de référence) de la liste correspondant à la variante trouvée — uniquement pour le type "Liste"</li>
                                    <li><code>${data.NOM_COLONNE}</code> : valeur d'une autre colonne de la ligne en cours</li>
                                </ul>
                                <div class="text-muted small">
                                    Si "To" (colonne de destination) est vide, le remplacement se fait directement dans la colonne source : indiquez au moins <code>${match}</code>, sinon le texte trouvé sera supprimé.
                                </div>
                            </b-popover>
                        </b-th>
                        <b-th>To (colonne de destination)</b-th>
                        <b-th></b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="(row, idx) in find" :key="'find' + idx">
                        <b-td>
                            <b-select v-model="row.type_search" size="sm" :options="[
                                { text: 'Valeur', value: 'valeur' },
                                { text: 'Colonne', value: 'colonne' },
                                { text: 'Liste', value: 'liste' }
                            ]" />
                        </b-td>
                        <b-td>
                            <template v-if="row.type_search === 'colonne'">
                                <b-input :list="'cec_search' + id" v-model="row.search" size="sm" placeholder="nom de la colonne CSV" />
                                <datalist :id="'cec_search' + id">
                                    <option v-for="(c, ci) in columns_data" :key="'cecs' + ci">{{ c }}</option>
                                </datalist>
                            </template>
                            <b-input-group v-else size="sm">
                                <b-input v-model="row.search" size="sm"
                                    :placeholder="row.type_search === 'liste' ? 'nom de la liste ou ${colonne}' : 'valeur de recherche'" />
                                <b-input-group-append v-if="row.type_search === 'liste'">
                                    <b-button size="sm" variant="outline-secondary" @click="open_list_editor(idx)" title="Gérer cette liste"><i class="fas fa-list"></i></b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-td>
                        <b-td>
                            <b-input :list="'cec_from' + id" v-model="row.search_column" size="sm" />
                            <datalist :id="'cec_from' + id">
                                <option v-for="(c, ci) in columns_data" :key="'cecf' + ci">{{ c }}</option>
                            </datalist>
                        </b-td>
                        <b-td>
                            <b-input :list="'cec_replace' + id" v-model="row.replace" size="sm" placeholder="${match}" />
                            <datalist :id="'cec_replace' + id">
                                <option value="${match}"></option>
                                <option value="${match_sensitive}"></option>
                                <option v-if="row.type_search === 'liste'" value="${list[match]}"></option>
                            </datalist>
                        </b-td>
                        <b-td>
                            <b-input :list="'cec_to' + id" v-model="row.dest_column" size="sm" />
                            <datalist :id="'cec_to' + id">
                                <option v-for="(c, ci) in columns_data" :key="'cect' + ci">{{ c }}</option>
                            </datalist>
                        </b-td>
                        <b-td>
                            <b-button size="sm" variant="danger" @click="find.splice(idx, 1)">✕</b-button>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
            <b-button size="sm" @click="add_find_row">+ Ajouter une recherche</b-button>
        </div>

        <b-modal
            :id="'modal_list_editor_' + id"
            size="xl"
            title="Gestion des listes"
            ok-title="Utiliser cette liste"
            cancel-title="Fermer"
            no-close-on-backdrop
            no-close-on-esc
            @ok="use_list"
            @shown="on_list_modal_shown"
        >
            <ElementEditor ref="element_list" _type="list" :minimal="false"></ElementEditor>
        </b-modal>
    </div>
</template>

<script>
    import uniqueId from "lodash.uniqueid";
    import ElementEditor from "../../views/Element.vue";

    export default {
        name: "chercher_et_classer",
        components: {
            ElementEditor
        },
        props: {
            data: { default: () => [] },
            files: { default: () => [] },
            client: { default: null },
            size: { default: 1000 },
            step_position: { default: 0 }
        },
        watch: {
            data: {
                deep: true,
                immediate: true,
                handler() {
                    if (this.data.length > 0) {
                        this.columns_data = Object.keys(this.data[0]);
                    }
                }
            }
        },
        data() {
            return {
                id: uniqueId(""),
                columns_data: [],

                show_character_option: false,
                character: "",
                find: [],

                list_row_index: null
            };
        },
        methods: {
            add_find_row() {
                this.find.push({
                    search: "",
                    type_search: "valeur",
                    search_column: "",
                    replace: "",
                    dest_column: ""
                });
            },
            open_list_editor(idx) {
                this.list_row_index = idx;
                this.$bvModal.show("modal_list_editor_" + this.id);
            },
            on_list_modal_shown() {
                if (!this.$refs.element_list) return;

                var row = this.find[this.list_row_index];
                var name = row && row.search ? row.search : "";

                if (name && !name.includes("${"))
                    this.$refs.element_list.load_name = name;
            },
            async use_list(bvModalEvt) {
                if (!this.$refs.element_list)
                    return;

                // on empêche la fermeture immédiate : on gère la fermeture nous même une fois l'enregistrement terminé
                if (bvModalEvt)
                    bvModalEvt.preventDefault();

                if (!this.$refs.element_list.name) {
                    this.$notify({
                        group: "info",
                        title: "Nom manquant",
                        text: "Merci de donner un nom à la liste avant de l'utiliser.",
                        type: "error"
                    });
                    return;
                }

                if (!this.$refs.element_list.version)
                    this.$refs.element_list.version = "1";

                if (this.list_row_index !== null && this.find[this.list_row_index])
                    this.find[this.list_row_index].search = this.$refs.element_list.name;

                try
                {
                    await this.$refs.element_list.save_db();
                }
                catch (err)
                {
                    console.error(err);
                    this.$notify({
                        group: "info",
                        title: "Erreur",
                        text: "La liste n'a pas pu être enregistrée.",
                        type: "error"
                    });
                    return;
                }

                this.$bvModal.hide("modal_list_editor_" + this.id);
            },
            save() {
                return {
                    character: this.show_character_option ? (this.character || "") : "",
                    find: this.find
                };
            },
            async load(data) {
                if (!data) data = {};
                this.character = data.character || "";
                this.show_character_option = !!data.character;
                this.find = Array.isArray(data.find) ? data.find.map(f => ({
                    search: f.search || "",
                    type_search: f.type_search || "valeur",
                    search_column: f.search_column || "",
                    replace: f.replace || "",
                    dest_column: f.dest_column || ""
                })) : [];
            }
        }
    };
</script>

<style scoped>
</style>
